import React from 'react';
import { func, string } from 'prop-types';
import { translate } from 'react-i18next';

import { STUDENT, TUTOR } from '@dragonfruit/constants/userRoles';

import { yearMonthDayFormat } from '@dragonfruit/utils/dateParser';

import styles from './BasicInfo.scss';

const cx = require('classnames/bind').bind(styles);

function BasicInfo({
  t,
  role,
  firstName,
  lastName,
  username,
  school,
  tutorDescription,
  gender,
  birthday,
}) {
  return (
    <div className={styles.userFieldContainer}>
      <div className={styles.doubleInput}>
        <div className={styles.fieldContainer}>
          <p className={styles.field}>{t('account.firstName')}</p>
          <p className={cx('value', !firstName && 'disabled')}>
            {firstName || t('account.notSelected')}
          </p>
        </div>
        <div className={styles.fieldContainer}>
          <p className={styles.field}>{t('account.lastName')}</p>
          <p className={cx('value', !lastName && 'disabled')}>
            {lastName || t('account.notSelected')}
          </p>
        </div>
      </div>
      {role === STUDENT ? (
        <div className={styles.input}>
          <div className={styles.fieldContainer}>
            <p className={styles.field}>{t('account.username')}</p>
            <p className={styles.value}>{username}</p>
          </div>
        </div>
      ) : (
        <div className={styles.doubleInput}>
          <div className={styles.fieldContainer}>
            <p className={styles.field}>{t('account.username')}</p>
            <p className={styles.value}>{username}</p>
          </div>
        </div>
      )}
      {role === TUTOR && (
        <React.Fragment>
          <div className={styles.input}>
            <div className={styles.fieldContainer}>
              <p className={styles.field}>{t('account.school')}</p>
              <p className={cx('value', !school && 'disabled')}>
                {school || t('account.notSelected')}
              </p>
            </div>
          </div>
          <div className={styles.input}>
            <div className={styles.fieldContainer}>
              <p className={styles.field}>{t('account.description.title')}</p>
              <p className={cx('value', !tutorDescription && 'disabled')}>
                {tutorDescription || t('account.notSelected')}
              </p>
            </div>
          </div>
        </React.Fragment>
      )}
      {role === STUDENT && (
        <React.Fragment>
          <div className={styles.input}>
            <div className={styles.fieldContainer}>
              <p className={styles.field}>{t('account.gender')}</p>
              <p className={cx('value', !gender && 'disabled')}>
                {gender || t('account.notSelected')}
              </p>
            </div>
          </div>
          <div className={styles.input}>
            <div className={styles.fieldContainer}>
              <p className={styles.field}>{t('account.birthday')}</p>
              <p className={cx('value', !birthday && 'disabled')}>
                {birthday
                  ? yearMonthDayFormat(birthday)
                  : t('account.notSelected')}
              </p>
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
}

BasicInfo.propTypes = {
  t: func.isRequired,
  birthday: string,
  firstName: string,
  gender: string,
  lastName: string,
  role: string,
  school: string,
  tutorDescription: string,
  username: string,
};

BasicInfo.defaultProps = {
  birthday: '',
  firstName: '',
  gender: '',
  lastName: '',
  role: '',
  school: '',
  tutorDescription: '',
  username: '',
};

export default translate(['account'])(BasicInfo);



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountProfile/components/BasicInfo/BasicInfo.jsx